<template>
  <v-layout row justify-center>
    <v-dialog v-model="editAccPlanDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="title">Editar plano de conta</v-card-title>
        <v-form ref="editExpenseForm" v-model="validEditAccPlanForm">
          <v-layout row wrap>
            <v-flex xs12 px-4>
              <v-text-field
                v-model="accPlanDataForm.code"
                label="Código"
                :rules="$store.state.formRules.required"
              />
            </v-flex>
            <v-flex xs12 px-4>
              <v-text-field
                v-model="accPlanDataForm.description"
                label="Descrição"
                :rules="$store.state.formRules.required"
              />
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blueGrey darken-1" flat @click="closeEditAccPlanDialog">Cancelar</v-btn>
            <v-btn color="primary" flat @click="doSave">Salvar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: {
    getAccountPlans: Function,
    editAccPlanDialog: Boolean,
    closeEditAccPlanDialog: Function,
    expenseData: Object
  },
  watch: {
    editAccPlanDialog: function(val) {
      if (val) {
        this.accPlanDataForm = { ...this.expenseData };
        //alert(val);
        //console.log(this.expenseData);
      } else {
        this.accPlanDataForm = {};
        this.$refs.editExpenseForm.resetValidation();
      }
    }
  },
  data() {
    return {
      accPlanDataForm: {},
      validEditAccPlanForm: true
    };
  },
  methods: {
    doSave() {
      if (!this.$refs.editExpenseForm.validate()) {
        return;
      }
      let query = this.accPlanDataForm;
      let obj = {
        url: "/api/planAccount/" + this.accPlanDataForm.id,
        query: query,
        method: "patch"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        if (!response) {
          return;
        }
        let opts = {
          message: "Grupo de despesa alterado com sucesso",
          type: "success"
        };
        this.$store.commit("showAlert", opts);
        this.getAccountPlans();
        this.closeEditAccPlanDialog();
      });
    }
  }
};
</script>